<template>
  <div>
    <template v-if="!form.id">
      <form-field-select
        label="Templates"
        @change="setCostTemplate"
      >
        <option v-if="loadingTemplates" :value="null" disabled>Loading...</option>
        <option v-else :value="null">No Template Selected</option>
        <option v-for="template in costTemplates" :key="template.id" :value="template">{{ template.label }}</option>
      </form-field-select>

      <hr class="my-5">
    </template>

    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-date-picker
      label="Date"
      v-model="form.date"
      :validation-errors="validationErrors.date"
    ></form-field-date-picker>

    <form-field-currency
      label="Amount"
      v-model="form.amount"
      :validation-errors="validationErrors.amount"
    ></form-field-currency>

    <form-field-editor
      label="Description"
      v-model="form.description"
      :validation-errors="validationErrors.description"
    ></form-field-editor>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import dates from "../services/dates";
  import utils from "../services/utils";
  import api from "../api";

  export default {
    name: "CampaignCostForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          label: '',
          date: null,
          amount: '',
          description: '',
          campaign_id: '',
        },

        loadingTemplates: false,
        costTemplates: [],
      }
    },
    created() {
      this.form = (this.formData) ? utils.clone({...this.defaultForm, ...this.formData}) : utils.clone(this.defaultForm);
    },
    mounted() {
      this.loadTemplates()
    },
    methods: {
      loadTemplates() {
        this.loadingTemplates = true;
        return api.campaignCostTemplate.all()
          .then(response => {
            this.costTemplates = response.data;
          })
          .finally(() => {
            this.loadingTemplates = false;
          })
      },
      setCostTemplate(costTemplate) {
        if (!costTemplate) {
          this.form = utils.clone(this.defaultForm);
          return;
        }

        this.form = {
          ...this.form,
          label: costTemplate.label,
          amount: costTemplate.amount,
          description: costTemplate.description,
        };
      },
      update() {
        const payload = {
          ...this.form,
          date: dates.formatAsDBDate(dates.convertJSDateToISO(new Date(this.form.date))),
        }

        return api.campaign_costs.update(payload)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Campaign cost was updated',
              type: 'is-success'
            });

            return res;
          });
      },
      create() {
        const payload = {
          ...this.form,
          date: dates.formatAsDBDate(dates.convertJSDateToISO(this.form.date))
        }

        return api.campaign_costs.create(payload)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Campaign cost was created',
              type: 'is-success'
            });

            return res;
          });
      },
      delete() {
        return api.campaign_costs.delete(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: res.data,
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
